// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';
import { SatcFamillesModel, SatcRequestModel } from './satcModels';
import { Family } from '../family/familyModels';

export const satcApi = createApi({
  reducerPath: 'satcApi',
  baseQuery: baseQuery('satc'),
  endpoints: (builder) => {
    return {
      getSatcFamilyInfo: builder.query<SatcFamillesModel, SatcRequestModel>({
        query: ({ famille_uuid, lang, pays_uuid, univers_uuid, from_product }) => {
          return {
            url: `familles/${famille_uuid}`,
            method: 'get',
            params: { lang, pays_uuid, from_product },
          };
        },
      }),
      getSatcFamilyGeneralInfo: builder.query<SatcFamillesModel, SatcRequestModel>({
        query: ({ famille_uuid, lang, pays_uuid, univers_uuid, from_product }) => {
          return {
            url: `familles/general/${famille_uuid}`,
            method: 'get',
            params: { lang, pays_uuid, from_product },
          };
        },
      }),
      getSatcUserFamily: builder.query<Family[], SatcRequestModel>({
        query: ({ lang, pays_uuid, univers_uuid }) => {
          return {
            url: `user/familles`,
            method: 'get',
            params: { lang, pays_uuid, univers_uuid },
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSatcFamilyInfoQuery, useGetSatcFamilyGeneralInfoQuery, useGetSatcUserFamilyQuery } = satcApi;
